import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Card from 'react-bootstrap/Card';


class ExamScMaths extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="danger">
            <h3>
              Examen national "الدورة العادية"
            </h3>
          </Alert>

          <Row>
              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة العادية للسنة الثانية باكالوريا  علوم رياضية 2018"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-2Bac-sci-maths-maths-2018.pdf" />

              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة العادية للسنة الثانية باكالوريا  علوم رياضية 2017"
               ty="Examen national"
               color1="#80ff80"
               content=""
               fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-2Bac-sci-maths-2017.pdf" />

              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة العادية للسنة الثانية باكالوريا  علوم رياضية 2016"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-2Bac-sci-maths-2016.pdf" />
          </Row>

          <Row>
              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة العادية للسنة الثانية باكالوريا  علوم رياضية 2015"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-2Bac-sci-maths-2015.pdf" />

              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة العادية للسنة الثانية باكالوريا  علوم رياضية 2014"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-2Bac-sci-maths-2014.pdf" />


              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة العادية للسنة الثانية باكالوريا  علوم رياضية 2013"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-2Bac-sci-maths-2013.pdf" />
          </Row>
          <hr/>
          <Alert variant="danger">
            <h3>
              Examen national "الدورة الإستدراكية"
            </h3>
          </Alert>


          <Row>
              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة الاستدراكية للسنة الثانية باكالوريا  علوم رياضية 2018"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-rat-2Bac-sci-maths-2018.pdf" />

              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة الاستدراكية للسنة الثانية باكالوريا  علوم رياضية 2016"
               ty="Examen national"
               color1="#80ff80"
               content=""
               fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-rat-2Bac-sci-maths-2016.pdf" />

              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة الاستدراكية للسنة الثانية باكالوريا  علوم رياضية 2015"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-rat-2Bac-sci-maths-2015.pdf" />
          </Row>

          <Row>
              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة الإستدراكية للسنة الثانية باكالوريا  علوم رياضية 2014"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-rat-2Bac-sci-maths-2014.pdf" />

              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة الاستدراكية للسنة الثانية باكالوريا  علوم رياضية 2013"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-rat-2Bac-sci-maths-2013.pdf" />

              <MyCard
              title="الامتحان الوطني في مادة الرياضيات الدورة الاستدراكية للسنة الثانية باكالوريا  علوم رياضية 2012"
              ty="Examen national"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/6/s1/exam/sci_exp/Exam-Corr-nat-maths-rat-2Bac-sci-maths-2012.pdf" />


          </Row>
      </div>
    );
  }
}

export default ExamScMaths;
